
import { useAuth } from '../context/AuthContext';

export const usePermission = () => {
  const { user } = useAuth();

  const hasPermission = (requiredPermissions) => {
    if (!user || !user.isAuthenticated) {
      return false;
    }

    // Admin has all permissions
    if (user.role === 'super_manage') {
      return true;
    }

    // Check if user has all required permissions
    return requiredPermissions.every(permission =>{
      if(user.role === 'admin' && permission === 'user:super_manage') {
        // Admin can manage users
        return false;
      }
      if(user.role === 'admin'){
        // Admin has all permissions except super_manage
        return true;
      }

      return  user.permissions && user.permissions.includes(permission);
    });
  };

  return { hasPermission, user };
};
